import React, {ChangeEventHandler, useCallback} from 'react'
import styled from 'styled-components'
import {InputPickerProps} from './InputPickerProps'

const StyledInput = styled.input`
  display: none;
`

const IMAGE_TYPE = ['image/jpg', 'image/jpeg', 'image/png']

export default function InputPicker({
  inputRef,
  accept = IMAGE_TYPE.join(', '),
  onChange,
  onLoadFiles,
  ...props
}: InputPickerProps) {
  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      const picker = inputRef.current

      onChange && onChange(event)

      if (picker?.files) {
        const {files} = picker
        onLoadFiles(Array.from(files))
        picker.value = ''
      }
    },
    [inputRef, onChange, onLoadFiles],
  )

  return (
    <StyledInput
      {...props}
      type="file"
      ref={inputRef}
      accept={accept}
      onChange={handleChange}
    />
  )
}
